import React from 'react';
import MediaQuery from 'react-responsive';
import { AboutNews } from 'components/organisms/aboutNews';
import NewsSectionMobile from 'components/organisms/newsSectionMobile';

const NewsSection = props => {
  const {
    newsData,
    sectionHeading,
    overlayButtonTextDesktop,
    overlayButtonTextMobile = '',
    showNotificationButton = false,
    toggleId,
  } = props.data;
  return (
    <div id={toggleId ? 'publications' : 'news'}>
      <MediaQuery minDeviceWidth={576}>
        <AboutNews
          data={newsData}
          sectionHeading={sectionHeading}
          overlayButtonText={overlayButtonTextDesktop}
          showNotificationButton={showNotificationButton}
          breadcrumbList={props.breadcrumbList}
        />
      </MediaQuery>
      <MediaQuery maxDeviceWidth={575.6}>
        <NewsSectionMobile
          data={newsData}
          sectionHeading={sectionHeading}
          overlayButtonText={overlayButtonTextMobile}
        />
      </MediaQuery>
    </div>
  );
};

export default NewsSection;
